import React from "react";
import { useSelector } from "react-redux";
import { useFormikContext, useField } from "formik";
import { ManualEmployerMatching } from "@qgiv/core-donor";
import {
    selectConfig,
    selectIsCms,
} from "../../../redux/slices/configSettingsSlice";
import {
    selectGiftDetails,
    selectDonorDetails,
} from "../../../redux/slices/donationDetailsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectMatchingGiftSettings } from "../../../redux/slices/donationSettingsSlice";
import { selectCmsControlById } from "../../../redux/slices/cmsSettingsSlice";

const ConnectedManualEmployerMatching = ({ controlId }) => {
    const isCms = useSelector(selectIsCms);
    const { subtotal } = useSelector(selectGiftDetails);
    const { currency } = useSelector(selectAllFormSettings);
    const { path } = useSelector(selectConfig);
    const { enableMatching } = useSelector(selectMatchingGiftSettings);
    const { options } = useSelector((state) =>
        selectCmsControlById(state, controlId),
    );
    const donorDetails = useSelector(selectDonorDetails);
    const { Company_Donation } = donorDetails;

    const {
        sectionHeading = "Your gift could be worth more!",
        description = "Find out if you’re eligible for a matching gift from your employer.",
        manualMatchingLabel = "This gift can be matched",
        manualMatchingHelpText = "",
        manualMatchingCompanyLabel = "Matching Company",
        manualMatchingAmountLabel = "Matching Amount",
    } = options;

    const { values, setValues } = useFormikContext();
    const { Match_Gift, Employer } = values;

    const [{ onBlur, onChange, ...field }] = useField({
        name: "Match_Gift",
        type: "checkbox",
    });
    const fieldProps = {
        ...field,
        id: "Match_Gift",
        name: "Match_Gift",
        handleChange: onChange,
        handleBlur: onBlur,
    };

    const employerField = Employer;
    const displayMatchingGift = enableMatching && !Company_Donation;

    // Donation total without Gift Assist
    const donationTotal = subtotal;

    const hasMatchableDonation = donationTotal > 0 || isCms;

    const isVisible = isCms ? !!Match_Gift : !!Match_Gift && subtotal > 0;

    const matchingGiftProps = {
        currency,
        displayMatchingGift,
        employerField,
        hasMatchableDonation,
        isStandardDonationForm: true,
        isVisible,
        sectionHeading,
        description,
        manualMatchingAmountLabel,
        manualMatchingCompanyLabel,
        manualMatchingHelpText,
        manualMatchingLabel,
        Match_Gift,
        noLeftGutter: true,
        path,
        teaserLabel: "",
        values,
        setValues,
        fieldProps,
    };

    return <ManualEmployerMatching {...matchingGiftProps} />;
};

export default ConnectedManualEmployerMatching;
